import LeftComponents from './Left';
import RightComponents from './Right';
import Button from './Button';

export const MenuComponents = {
  LeftComponents,
  RightComponents,
  Button,
};
